import { type ReactNode } from 'react'
import { AboutButton } from '@versports/ui'
import { VerSportsLogo } from '@versports/ui'

/**
 * Layout for the marketing / pre-login screens (login, public landing,
 * eventually a "esperando activación"). Mirrors the vr-app `LandingOverlay`:
 * full-viewport gradient from `surface` to `surface-elevated`, big centered
 * official VerSports lockup at the top, content stack below, and the global
 * "Acerca de" floating button (`AboutButton`) in the corner.
 *
 * The global Topbar is **not** rendered here because there's nothing to
 * navigate to yet — the post-login Topbar with user identity lives in
 * `AppShell`. `AboutButton` stays so the brand / legal / powered-by rule
 * (CLAUDE.md) is honored on every page. No bottom NavBar here → no
 * `navOffset`.
 */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-b from-surface to-surface-elevated">
      <div className="flex flex-1 flex-col items-center justify-center gap-lg px-lg py-2xl">
        <VerSportsLogo size="lg" />
        {children}
      </div>
      <AboutButton />
    </div>
  )
}
